import { render, staticRenderFns } from "./Cambio.vue?vue&type=template&id=193619e5&"
import script from "./Cambio.vue?vue&type=script&lang=js&"
export * from "./Cambio.vue?vue&type=script&lang=js&"
import style0 from "./Cambio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports